import React, { useEffect, useState } from 'react';
import { Table, Tag, message, Image } from 'antd';
import { getListTenantPlan } from '@/services/athena';
const PlanCourses = (props) => {
  const { tenantId } = props;
  const [pageData, setPageData] = useState({
    currentPage: 1,
    pageSize: 10,
    count: 0,
  });
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    initListTenantPlan(pageData);
  }, [tenantId]);

  const handlerPage = (page) => {
    const pages = {
      currentPage: page.current,
      pageSize: page.pageSize,
    };
    setPageData({ ...pageData, ...pages });
    initListTenantPlan(pages);
  };

  const initListTenantPlan = (pageData) => {
    if (!tenantId) {
      return;
    }
    const params = {
      requestData: { tenantId },
      page: pageData,
    };
    getListTenantPlan(params).then((res) => {
      if (res.code !== '00000') {
        message.error(res.msg);
        return;
      }
      setPageData({
        ...pageData,
        count: res?.page?.count,
      });
      setTableData(res.data || []);
    });
  };

  const columns = [
    {
      title: '计划ID',
      key: 'id',
      dataIndex: 'id',
    },
    {
      title: '计划封面',
      key: 'planCover',
      dataIndex: 'planCover',
      hideInSearch: true,
      render: (text) => {
        return <Image height={73} width={140} src={text} />;
      },
    },
    {
      title: '计划名称',
      key: 'planName',
      dataIndex: 'planName',
      width: 200,
      render: (text, record) => {
        return (
          <a
            href={`/action/exclusiveProgram/detail?id=${record.id}`}
            target="_blank"
          >
            {text}
          </a>
        );
      },
    },
    {
      title: '全部课程节数',
      key: 'totalNum',
      dataIndex: 'totalNum',
    },
    {
      title: '特色课节数',
      key: 'specialCourseNum',
      dataIndex: 'specialCourseNum',
    },
    {
      title: '一起练节数',
      key: 'togetherCourseNum',
      dataIndex: 'togetherCourseNum',
    },
    {
      title: '系统课节数',
      key: 'templateCourseNum',
      dataIndex: 'templateCourseNum',
    },
    {
      title: '是否精选',
      dataIndex: 'isCarefulChoose',
      key: 'isCarefulChoose',
      render: (text) => {
        return <Tag color={text ? 'green' : 'red'}>{text ? '是' : '否'}</Tag>;
      },
    },
    {
      title: '创建人',
      key: 'creatorName',
      dataIndex: 'creatorName',
    },
  ];

  return (
    <Table
      rowKey="id"
      columns={columns}
      scroll={{ x: 'max-content' }}
      dataSource={tableData}
      pagination={{
        total: pageData.count,
        pageSize: pageData.pageSize,
        showTotal: (total, range) =>
          `第 ${range[0]}-${range[1]} 条/总共 ${total} 条`,
      }}
      onChange={handlerPage}
    />
  );
};

export default PlanCourses;
